import { useNavigate } from 'react-router-dom';
import '../css/AdminSidebar.css';

function AdminSidebar({ active = '', groupId, onRefresh }) {
  const navigate = useNavigate();
  const selectedGroupId = Number(groupId || localStorage.getItem('last_group_id') || 0);
  const go = path => navigate(path);
  const items = [
    { key: 'dashboard', icon: '🏠', label: 'Dashboard', action: () => go('/dashboard') },
    { key: 'matches', icon: '🏸', label: 'Group Matches', disabled: !selectedGroupId, action: () => go(`/admin/group/${selectedGroupId}/matches`) },
    { key: 'planner', icon: '✨', label: 'Match Planner', disabled: !selectedGroupId, action: () => go(`/match-planner/${selectedGroupId}`) },
    { key: 'monitor', icon: '🖥️', label: 'Admin Monitor', action: () => go('/admin_monitor') },
    { key: 'users', icon: '🛡️', label: 'ผู้เล่นทั้งหมด', action: () => go('/admin/users') },
    { key: 'rewards', icon: '🎁', label: 'Admin Reward', action: () => go('/admin/rewards') }
  ];

  return <aside className="admin-shared-sidebar" aria-label="เมนูผู้ดูแลระบบ">
    <strong>🏸 Admin<br />Dashboard</strong>
    <nav>{items.map(item => <button type="button" key={item.key} className={active===item.key?'is-active':''} disabled={item.disabled} onClick={item.action}><span>{item.icon}</span>{item.label}</button>)}</nav>
    {onRefresh && <button type="button" className="admin-sidebar-refresh" onClick={onRefresh}>🔄 Refresh</button>}
  </aside>;
}

export default AdminSidebar;
